import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISiteDetailsModel } from '@apps-common/types/portal/site-details'

export const QUERY_GET_SITE_DETAILS = (unitId?: string) => ['getSiteDetails', unitId].filter(Boolean)

export const getSiteDetails = async (unitId: string): Promise<ISiteDetailsModel> =>
  axios.get(`/sitedetails/getsitedetails?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getSiteDetails

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetSiteDetails = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_SITE_DETAILS(unitId),
    queryFn: () => getSiteDetails(unitId)
  })
